<template>
  <div class="notification--text">
    <p>{{ $root.localize("screens.NotFound.message") }}</p>
    <router-link v-bind:to="{ name: 'Home' }" class="btn btn-primary">{{
        $root.localize("global.buttons.goHome")
    }}</router-link>
</div>
  
  
</template>

<script>
import BodyClass from "../mixins/BodyClass";
import MainClass from "../mixins/MainClass";
import PageTitle from "../mixins/PageTitle";
export default {
  name: "NotFound",

  mixins: [BodyClass, MainClass, PageTitle],

  data() {
    /* Defaults to password hidden state */
    return {
      bodyClass: "notification",
      mainClass: "notification--body",
    };
  },

};
</script>
